import React, { useState } from "react";

const SubscriptionCard = ({ onBack }) => {
  const [selectedPlan, setSelectedPlan] = useState("Yearly");

  const handleSelect = (plan) => {
    setSelectedPlan(plan);
  };

  return (
    <div
      className="min-h-screen p-6 font-sans"
      style={{
        background:
          "linear-gradient(to top, #FEA375 0%, #F6B3F6 30%, #60B7FF 70%)",
      }}
    >
      <div className="max-w-md mx-auto relative pt-8">
        {/* Header */}
        <div className="text-center mb-8">
          <span className="inline-block bg-[#EEEEEE] text-[#1E0A1E] rounded-full font-bold px-4 py-2 text-[14px] font-space-grotesk text-[#1E0A1E] mb-4">
            BETA launch offer
          </span>
          <h1 className="text-[50px] leading-[55px] font-young-serif font-normal text-[#1E0A1E] mb-4">
            Start your
            <br />
            FREE week!
          </h1>
          <div className="mb-[60px]">
            <p
              style={{ letterSpacing: "-1px" }}
              className="text-[20px] leading-[25px] font-normal font-space-grotesk text-[#1E0A1E]"
            >
              Followed by a launch discount
              <br />
              on subscriber plans
            </p>
          </div>
        </div>

        <div className="space-y-4">
          <div
            onClick={() => handleSelect("Yearly")}
            className={`cursor-pointer border rounded-3xl mb-[35px] p-5 relative  ${
              selectedPlan === "Yearly"
                ? "bg-black text-[#EEEEEE] border-black shadow-[2px_2px_4px_rgba(0,0,0,0.05),_5px_5px_2px_rgba(0,0,0,0.15)]"
                : "bg-transparent text-black border-[#FFFFFF]"
            }`}
          >
            <span
              className={`absolute -top-4 border text-[12px] font-bold font-space-grotesk  left-4 px-3 py-1 rounded-full ${
                selectedPlan === "Yearly"
                  ? "bg-black text-[#EEEEEE]"
                  : "bg-[rgb(137_181_252)] text-black border-[#FFFFFF]"
              }`}
            >
              1st Week FREE
            </span>
            <div className="flex justify-between items-center">
              <span className="text-[30px] font-young-serif font-normal">
                Yearly
              </span>
              <div className="flex items-center">
                <span className="text-[30px] font-bold font-space-grotesk">
                  €7.49
                </span>
                <span className="text-[12px] font-bold font-space-grotesk">
                  /mo
                </span>
              </div>
            </div>
            <p className="text-[12px] font-medium text-right font-space-grotesk">
              <span className="text-[#929292]">
                BETA Discount <span className="line-through">£155.88</span>{" "}
              </span>{" "}
              €89.99 Billed annually
            </p>

            <span
              style={{
                background: "linear-gradient(to right, #FAFAFA, #ECDA66)",
              }}
              className="absolute -top-4 right-4 text-black text-[14px] px-3 font-space-grotesk font-bold py-1 rounded-full"
            >
              Save 42%
            </span>
          </div>

          <div
            onClick={() => handleSelect("Monthly")}
            className={`cursor-pointer  rounded-3xl p-5 relative ${
              selectedPlan === "Monthly"
                ? "bg-black text-[#EEEEEE] shadow-[2px_2px_4px_rgba(0,0,0,0.05),_5px_5px_2px_rgba(0,0,0,0.15)]"
                : "bg-transparent border text-black border-grey-400"
            }`}
          >
            <span
              className={`absolute -top-4 text-[12px] left-4 border font-bold px-3 py-1 font-space-grotesk rounded-full shadow-sm ${
                selectedPlan === "Monthly"
                  ? "bg-black text-[#EEEEEE]"
                  : "bg-[rgb(191_181_250)] text-black border-grey-400"
              }`}
              style={{ zIndex: 10 }}
            >
              1st Week FREE
            </span>
            <div className="flex justify-between items-center">
              <span className="text-[30px] font-young-serif font-normal">
                Monthly
              </span>
              <div className="flex items-center">
                <span className="text-[30px] font-bold font-space-grotesk">
                  €12.99
                </span>
                <span className="text-[12px] font-bold font-space-grotesk">
                  /mo
                </span>
              </div>
            </div>
            <p className="text-[12px] font-medium text-right font-space-grotesk">
              BETA Discount <span className="line-through">€14.99</span>{" "}
            </p>
          </div>
        </div>

        <div className="flex justify-center mt-16">
          <button className="bg-[#1E0A1E] font-medium text-[#EEEEEE] rounded-full py-2 pl-[1rem] pr-[1rem] font-space-grotesk text-[20px] shadow-[2px_2px_4px_rgba(0,0,0,0.05),_5px_5px_2px_rgba(0,0,0,0.15)]">
            Start my FREE Week!
          </button>
        </div>

        <div
          onClick={onBack}
          className=" font-space-grotesk text-center font-medium text-[16px] text-[#1E0A1E] mt-6"
        >
          Cancel any time
        </div>
      </div>
    </div>
  );
};

export default SubscriptionCard;
